import { getJson } from '@/helpers/ajax';
import { useQuery } from '@tanstack/react-query';
import getBaseUrl from '@uikit/helpers/getBaseUrl';

const TRUSTED_SHOPS_REVIEWS_PATH = '/json-data/trusted-shops-reviews.json';

export type TrustedShopReview = {
  id: string;
  title: string;
  comment: string;
  customerShortName: string;
  date: string; // ISO 8601
  rating: number;
  isVerified: boolean;
};

const getTrustedShopsReviews = async (): Promise<TrustedShopReview[]> => {
  const url = new URL(TRUSTED_SHOPS_REVIEWS_PATH, getBaseUrl());
  const data = await getJson<TrustedShopReview[]>(url);
  return data ?? [];
};

export function useTrustedShopsReviews() {
  return useQuery({
    queryKey: ['trusted-shops-reviews'],
    queryFn: getTrustedShopsReviews,
  });
}
